import React from 'react';
import PropTypes from 'prop-types';
import {
  NavigationButton,
  NavigationButtonGroup,
} from 'web-ui-components/lib/navigation/buttons';
import AccountsStore from '../../stores/AccountsStore';
import FavouritesStore from '../../stores/AccountsStore/FavouritesStore';
import { fastLinksMap } from './HomePageConstants';

const { payments, managePayments, statementPreference } = fastLinksMap;

const FastLinks = ({ onLinkClick }) => {
  const fastLinks = [];

  if (AccountsStore.getPaymentsFlag() || FavouritesStore.getPaymentsFlag()) {
    fastLinks.push(
      <NavigationButton.Secondary
        key={`fastLinks_${payments.text}`}
        data-test-id="fast-links-move-money-button"
        labelText={payments.text}
        onClick={() => onLinkClick(payments.id)}
      />
    );
  }
  if (
    AccountsStore.getManagePaymentsFlag() ||
    FavouritesStore.getManagePaymentsFlag()
  ) {
    fastLinks.push(
      <NavigationButton.Secondary
        key={`fastLinks_${managePayments.text}`}
        data-test-id="fast-links-view-scheduled-payments-button"
        labelText={managePayments.text}
        onClick={() => onLinkClick(managePayments.id)}
      />
    );
  }
  if (
    AccountsStore.getStmtPreferenceFlag() ||
    FavouritesStore.getStmtPreferenceFlag()
  ) {
    fastLinks.push(
      <NavigationButton.Secondary
        key={`fastLinks_${statementPreference.text}`}
        data-test-id="fast-links-go-paper-free-button"
        labelText={statementPreference.text}
        onClick={() => onLinkClick(statementPreference.id)}
      />
    );
  }
  return (
    <section>
      <NavigationButtonGroup secondaryButtons={fastLinks} />
    </section>
  );
};

FastLinks.propTypes = {
  onLinkClick: PropTypes.func.isRequired,
};

export default FastLinks;
